
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const ConsignmentImportsNoEventsAction = (props) => {
    const handleEventClick = (e) => {
        e.stopPropagation();
        //console.log("Overspeed ",props);
        props.context.componentParent.onShowConsignmentImportsEventsClick(0);
    };
    

    return (
        <div>
            <button onClick={handleEventClick} className="custom-btn f22 label label-success" 
            title="High Seas" style={{color:"#ccc"}} ><i className="icofont icofont-ship-alt"></i> &nbsp;</button>
            
        </div>
    );
};

export default ConsignmentImportsNoEventsAction;
